'use client';

import { useEffect, useRef } from 'react';

export type ModalVideo = { title: string; video_url: string; thumbnail_url: string | null };

// AI 아바타 상담 Q&A 영상 팝업 (홈 거래 진행 프로세스 계약금 영상, 자주 묻는 질문, 고객Q&A 보내기). ESC·바깥 클릭으로 닫기, 열린 동안 뒤 페이지 스크롤 잠금
// onWatched: 팝업이 닫힐 때 실제로 재생된 시간(초)을 알려 준다 (앞뒤로 건너뛴 구간은 빼고 셈)
export default function VideoModal({
  video,
  onClose,
  onWatched,
}: {
  video: ModalVideo;
  onClose: () => void;
  onWatched?: (seconds: number) => void;
}) {
  const watchedRef = useRef(0);
  const lastTimeRef = useRef<number | null>(null);
  const onWatchedRef = useRef(onWatched);
  onWatchedRef.current = onWatched;

  useEffect(() => () => onWatchedRef.current?.(watchedRef.current), []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return (
    <div data-component-id="src/components/common/VideoModal.tsx:39:4" data-component-path="src/components/common/VideoModal.tsx" data-component-line="39" data-component-end-line="81" data-component-file="VideoModal.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-%5B100%5D%20flex%20items-center%20justify-center%20bg-black%2F70%20p-4%22%7D"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={video.title}
      onClick={onClose}
    >
      <div data-component-id="src/components/common/VideoModal.tsx:46:6" data-component-path="src/components/common/VideoModal.tsx" data-component-line="46" data-component-end-line="80" data-component-file="VideoModal.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-md%20overflow-hidden%20rounded-2xl%20bg-white%20shadow-2xl%22%7D"
        className="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div data-component-id="src/components/common/VideoModal.tsx:50:8" data-component-path="src/components/common/VideoModal.tsx" data-component-line="50" data-component-end-line="62" data-component-file="VideoModal.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20gap-3%20px-4%20py-3%20border-b%20border-border%22%7D" className="flex items-center justify-between gap-3 px-4 py-3 border-b border-border">
          <div data-component-id="src/components/common/VideoModal.tsx:51:10" data-component-path="src/components/common/VideoModal.tsx" data-component-line="51" data-component-end-line="51" data-component-file="VideoModal.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-w-0%20text-sm%20font-semibold%20text-text-primary%20break-keep%22%7D" className="min-w-0 text-sm font-semibold text-text-primary break-keep">{video.title}</div>
          <button data-component-id="src/components/common/VideoModal.tsx:52:10" data-component-path="src/components/common/VideoModal.tsx" data-component-line="52" data-component-end-line="61" data-component-file="VideoModal.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22flex%20h-8%20w-8%20flex-shrink-0%20items-center%20justify-center%20rounded-lg%20hover%3Abg-secondary%20transition-smooth%22%7D"
            type="button"
            onClick={onClose}
            aria-label="닫기"
            className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg hover:bg-secondary transition-smooth"
          >
            <svg data-component-id="src/components/common/VideoModal.tsx:58:12" data-component-path="src/components/common/VideoModal.tsx" data-component-line="58" data-component-end-line="60" data-component-file="VideoModal.tsx" data-component-name="svg" data-component-content="%7B%22elementName%22%3A%22svg%22%2C%22className%22%3A%22h-4%20w-4%22%7D" viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4" aria-hidden="true">
              <path data-component-id="src/components/common/VideoModal.tsx:59:14" data-component-path="src/components/common/VideoModal.tsx" data-component-line="59" data-component-end-line="59" data-component-file="VideoModal.tsx" data-component-name="path" data-component-content="%7B%22elementName%22%3A%22path%22%7D" d="M5.3 5.3a1 1 0 0 1 1.4 0L10 8.6l3.3-3.3a1 1 0 1 1 1.4 1.4L11.4 10l3.3 3.3a1 1 0 0 1-1.4 1.4L10 11.4l-3.3 3.3a1 1 0 0 1-1.4-1.4L8.6 10 5.3 6.7a1 1 0 0 1 0-1.4Z" />
            </svg>
          </button>
        </div>
        <video data-component-id="src/components/common/VideoModal.tsx:63:8" data-component-path="src/components/common/VideoModal.tsx" data-component-line="63" data-component-end-line="79" data-component-file="VideoModal.tsx" data-component-name="video" data-component-content="%7B%22elementName%22%3A%22video%22%2C%22className%22%3A%22block%20w-full%20aspect-square%20bg-black%20object-contain%22%7D"
          src={video.video_url}
          poster={video.thumbnail_url ?? undefined}
          controls
          autoPlay
          playsInline
          onTimeUpdate={(e) => {
            const t = e.currentTarget.currentTime;
            const prev = lastTimeRef.current;
            if (prev !== null && t > prev && t - prev < 1.5) watchedRef.current += t - prev;
            lastTimeRef.current = t;
          }}
          onSeeking={(e) => {
            lastTimeRef.current = e.currentTarget.currentTime;
          }}
          className="block w-full aspect-square bg-black object-contain"
        />
      </div>
    </div>
  );
}
